import { a as languages } from "../../core-8vQkh0Rd.js";
import { n as re } from "../../shared-BPLAFNn7.js";
//#region src/prism/languages/kumir.js
/** Regular expression for characters that are not allowed in identifiers. */
var nonId = ["\\s\0-\"-/:-?[-^`{-~"];
languages.kum = languages.kumir = {
	"comment": /\|.*/,
	"prolog": /#.*/g,
	"string": /"[^\n"]*"|'[^\n']*'/g,
	"boolean": {
		pattern: re("(^|[<0>])(?:да|нет)(?![^<0>])", nonId),
		lookbehind: true
	},
	"operator-word": {
		pattern: re("(^|[<0>])(?:и|или|не)(?![^<0>])", nonId),
		lookbehind: true,
		alias: "keyword"
	},
	"system-variable": {
		pattern: re("(^|[<0>])знач(?![^<0>])", nonId),
		lookbehind: true,
		alias: "keyword"
	},
	"type": [{
		pattern: re("(^|[<0>])(?:вещ|лит|лог|сим|цел)(?: *таб)?(?![^<0>])", nonId),
		lookbehind: true,
		alias: "builtin"
	}, {
		pattern: re("(^|[<0>])(?:компл|сканкод|файл|цвет)(?![^<0>])", nonId),
		lookbehind: true,
		alias: "important"
	}],
	"keyword": {
		pattern: re("(^|[<0>])(?:алг|арг(?: *рез)?|ввод|ВКЛЮЧИТЬ|вс[её]|выбор|вывод|выход|дано|для|до|дс|если|иначе|исп|использовать|кон(?:(?: +|_)исп)?|кц(?:(?: +|_)при)?|надо|нач|нс|нц|от|пауза|пока|при|раза?|рез|стоп|таб|то|утв|шаг)(?![^<0>])", nonId),
		lookbehind: true
	},
	"name": {
		pattern: re("(^|[<0>])[^\\d<0>][^<0>]*(?: +[^<0>]+)*(?![^<0>])", nonId),
		lookbehind: true
	},
	"number": {
		pattern: re("(^|[<0>])(?:\\B\\$[a-f\\d]+\\b|(?:\\b\\d+(?:\\.\\d*)?|\\B\\.\\d+)(?:e[+-]?\\d+)?)(?![^<0>])", nonId, "i"),
		lookbehind: true
	},
	"punctuation": /:=|[()[\],:;]/,
	"operator-char": {
		pattern: /\*\*?|<>|>=?|<=?|[=/+-]/,
		alias: "operator"
	}
};
//#endregion

//# sourceMappingURL=kumir.js.map